import React, { useCallback, useState } from 'react';

import Cell from '../Cell';
import { FloatingCellTVProps } from '../types';
import { useIsInbound } from '../useIsInbound';

const FloatingCellTV = ({
    config,
    item,
    rect,
    xVisibleStartOffset,
    xVisibleEndOffset,
    renderContent,
    onFocus,
}: FloatingCellTVProps) => {
    const [focused, setFocused] = useState(false);

    const inbound = useIsInbound(rect, xVisibleStartOffset, xVisibleEndOffset);

    const _onFocus = useCallback(() => {
        setFocused(true);
        onFocus?.(item);
    }, [item, onFocus]);

    const onBlur = useCallback(() => {
        setFocused(false);
    }, []);

    return (
        <Cell
            config={config}
            item={item}
            renderContent={renderContent}
            onFocus={_onFocus}
            onBlur={onBlur}
            selected={focused}
            focusable={inbound}
        />
    );
};

export default FloatingCellTV;
